import MiniCasco from './views/miniCasco.c';
export default MiniCasco;
